import React from "react";
import { CXContext } from "./cxContext";
import * as dc from "dc";
import * as d3 from 'd3';
import { rhythm } from "../utils/typography.js";
import { css } from "glamor";

const commasFormatter = (num) => {
  return Math.abs(num) > 999 ? Math.sign(num)*((Math.abs(num)/1000).toFixed(1)) + 'k' : Math.sign(num)*Math.abs(num)//d3.format(",.0f");
}

export const TotalTemplate = props => {
    /*
    We render the dc chart using an effect. We want to pass the chart as a prop after the dc call,
    but there is nothing by default to trigger a re-render and the prop, by default would be undefined.
    To solve this, we hold a state key and increment it after the effect ran.
    By passing the key to the parent div, we get a rerender once the chart is defined.
    */
  const context = React.useContext(CXContext);
  const [chart,updateChart] = React.useState(null);
  const ndx = context.ndx;
  const tags = context.tags
  //const calc = metric//context.calc;
  const div = React.useRef(null);
  React.useEffect(() => {
      const newChart = props.chartFunction(div.current, ndx, tags); // chartfunction takes the ref and does something with it
      //const tag = props.chartVizFunc(div.current, 0);
      newChart.render();
      updateChart(newChart);
  },1); {/*Run this exactly once */}

  const chartStyles  = css({
    width:'100%',
    textAlign: 'center',
    color: 'white',
    fontWeight: '600',
    fontSize: '20px',
    boxSizing:'border-box',
    //backgroundColor: 'rgb(49, 130, 189)',
    padding:rhythm(.1),
    marginBottom: rhythm(.1),
    // paddingRight: rhythm(.4),
    // paddingLeft: rhythm(.4),
    float: 'center',
    '& label':{
      textTransform:'capitalize',
      color: '#eee',
      fontWeight: '400',
      display: 'block',
      fontSize: '16px',
      //float: 'none'
      //textDecoration:'underline',
    },
    '& p':{
      fontSize: '14px',
      //display: 'inline-block',
      float:'right',
      paddingRight: '60px',
      height: '10px',
      marginBottom: 0,
      //width: '30%'
    }
  })
  return (
    <div
      ref={div}
      {...chartStyles}
    >
      <label >{props.title}</label>
      {props.val != undefined && <p> {props.val}</p>}
    </div>
  );
};
